import * as React from "react";
const SvgIcDotBullet = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 5.625, cy: 9, r: 1.125, fill: "currentColor" }));
export default SvgIcDotBullet;
